import { render, staticRenderFns } from "./RecordInfo.vue?vue&type=template&id=3f284959&scoped=true"
import script from "./RecordInfo.vue?vue&type=script&lang=js"
export * from "./RecordInfo.vue?vue&type=script&lang=js"
import style0 from "./RecordInfo.vue?vue&type=style&index=0&id=3f284959&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f284959",
  null
  
)

export default component.exports